import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d43d122"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "icon" }
const _hoisted_2 = ["width", "height"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", {
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "32"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m461.81 53.81a4.4 4.4 0 0 0 -3.3-3.39c-54.38-13.3-180 34.09-248.13 102.17a294.9 294.9 0 0 0 -33.09 39.08c-21-1.9-42-.3-59.88 7.5-50.49 22.2-65.18 80.18-69.28 105.07a9 9 0 0 0 9.8 10.4l81.07-8.9a180.29 180.29 0 0 0 1.1 18.3 18.15 18.15 0 0 0 5.3 11.09l31.39 31.39a18.15 18.15 0 0 0 11.1 5.3 179.91 179.91 0 0 0 18.19 1.1l-8.89 81a9 9 0 0 0 10.39 9.79c24.9-4 83-18.69 105.07-69.17 7.8-17.9 9.4-38.79 7.6-59.69a293.91 293.91 0 0 0 39.19-33.09c68.38-68 115.47-190.86 102.37-247.95zm-163.15 159.86a42.7 42.7 0 1 1 60.38 0 42.65 42.65 0 0 1 -60.38 0z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "m109.64 352a45.06 45.06 0 0 0 -26.35 12.84c-17.62 17.68-19.29 83.16-19.29 83.16s65.52-1.67 83.15-19.31a44.73 44.73 0 0 0 12.85-26.37" })
], -1))
const _hoisted_4 = [
  _hoisted_3
]


export default /*#__PURE__*/_defineComponent({
  __name: 'icon-rocket',
  props: {
    size: {
      type: Number,
      default: 24
    }
  },
  setup(__props) {

  //eslint-disable-next-line
  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", {
      width: __props.size,
      height: __props.size,
      viewBox: "0 0 512 512",
      xmlns: "http://www.w3.org/2000/svg"
    }, _hoisted_4, 8, _hoisted_2))
  ]))
}
}

})